import { calculateDiffInDays } from './date';

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getChartTick = (duration: string, value: string) => {
  const d = new Date(value);
  // console.log('dd', d.toDateString());
  switch (duration) {
    case '1M':
    case '3M':
      return `${d.getDate()} ${months[d.getMonth()]}`;
    case '6M':
    case '1Y':
      return `${months[d.getMonth()]} ${d.getFullYear() - 2000}`;
    case '3Y':
    case '5Y':
    case '10Y':
    default:
      return `${d.getFullYear()}`;
  }
};

export const getTicksCount = (duration: string) => {
  switch (duration) {
    case '1M':
      // show weekly. 4.3 weeks in a month
      return 4.3;
    case '3M':
      // show bi-weekly. 13 weeks in 3 month
      return 6.5;
    case '6M':
      // show monthly.
      return 6;
    case '1Y':
      // show bi-monthly.
      return 6;
    case '3Y':
      // show yearly
      return 3;
    case '5Y':
      // show yearly
      return 5;
    case '10Y':
      // show yearly
      return 10;
    default:
      return;
  }
};

export const getDurationBasedData = (minDate: string, maxDate: string) => {
  const diffInDays = calculateDiffInDays(minDate, maxDate);
  if (diffInDays >= 3645) return '10Y'; // max 1826 days in 5 years
  if (diffInDays >= 1820) return '5Y'; // max 1096 days in 3 years
  if (diffInDays >= 1088) return '3Y'; // max 365 days in 1 years
  if (diffInDays >= 360) return '1Y'; // max 184 days in 6 months
  if (diffInDays >= 153) return '6M'; // max 92 days in 3 months
  if (diffInDays >= 85) return '3M'; // max 31 days in 1 month
  return '1M';
};

const getBreakpoint = (dur: string) => {
  switch (dur) {
    case '1M':
      return 7;
    case '3M':
      return 15;
    case '6M':
      return 30;
    case '1Y':
      return 60;
    case '3Y':
      return 365;
    case '5Y':
      return 365;
    case '10Y':
      return 730;
    default:
      return 365;
  }
};

export const shouldShowTick = (latestDate: string, curDate: string, prevDate: string, dur: string) => {
  const breakpoint = getBreakpoint(dur);
  const prevDateDiff = calculateDiffInDays(prevDate, latestDate);
  const curDateDiff = calculateDiffInDays(curDate, latestDate);
  if (
    // check for if current date is a breakpoint or immediate next to a breakpoint if no data for breakpoint
    curDateDiff % breakpoint === 0 ||
    (prevDateDiff % breakpoint !== 0 && curDateDiff % breakpoint > prevDateDiff % breakpoint)
  ) {
    return true;
  }
  return false;
};
